import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[dialogBackdrop]'
})
export class DialogBackdropDirective {
  private backdrop!: HTMLElement;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    const dialog: HTMLDialogElement = this.el.nativeElement;

    // cfaete backdrop element
    this.backdrop = this.renderer.createElement('div');
    this.renderer.addClass(this.backdrop, 'backdrop');

    const observer = new MutationObserver(() => { // watch for dialog state
      if (dialog.open) {
        this.showBackdrop(dialog);
      } else {
        this.hideBackdrop();
      }
    });

    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  private showBackdrop(dialog: HTMLElement) {
    const parent = dialog.parentNode;
    this.renderer.insertBefore(parent, this.backdrop, dialog);
  }

  private hideBackdrop() {
    if (this.backdrop.parentNode) {
      this.renderer.removeChild(this.backdrop.parentNode, this.backdrop);
    }
  }

  ngOnDestroy() {
    this.hideBackdrop();
  }
}
